module.exports = __webpack_public_path__ + "static/img/memberLC.dc2d897.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investTeam/memberLC.png
// module id = AyC5
// module chunks = 0